import { render, staticRenderFns } from "./ContentToPdf.vue?vue&type=template&id=8473aa62&"
import script from "./ContentToPdf.vue?vue&type=script&lang=js&"
export * from "./ContentToPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports